import mutations from './mutations.js';
import getters from './getters.js';
import actions from './actions.js';
export default {
  namespaced: true,
  state() {
    return {
      isLoggedIn: false,
      userID: null,
      token: null,
      email: '',
      school: '',
      fname: '',
      lname: '',
      prework: false,
      experiences: [],
      active_experience_id: false,
      settings: false,
      notifications: [],
      available_experiences: [],
      certificate_teachers: false,
      user_settings: null,
      ctWhsEnabled: false,
    };
  },
  mutations,
  actions,
  getters,
};
